module.exports = __webpack_public_path__ + "static/media/bored.c516e103.svg";